/* Thin fetch client for the MARKETING Hero API. Cookies carry the session. */

export class ApiError extends Error {
  constructor(public status: number, public code: string, message?: string) {
    super(message || code);
  }
}

async function req<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`/api${path}`, {
    method,
    headers: body ? { "content-type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
    credentials: "same-origin",
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new ApiError(res.status, data.error || "error", data.detail || data.error);
  return data as T;
}

export const api = {
  get: <T>(p: string) => req<T>("GET", p),
  post: <T>(p: string, b?: unknown) => req<T>("POST", p, b),
  put: <T>(p: string, b?: unknown) => req<T>("PUT", p, b),
  del: <T>(p: string) => req<T>("DELETE", p),
};

/* ------- shared response types ------- */
export interface PublicUser { id: string; email: string; name: string; role: string; }
export interface AuthStatus { hasOwner: boolean; authenticated: boolean; user: PublicUser | null; }
export interface Brand {
  id: string; workspaceId: string; name: string; kind: string; color?: string | null;
  isActive: number; createdAt: number; updatedAt: number;
}
export interface BusinessProfile { [k: string]: unknown; completeness: number; }
export interface Settings { provider: string; model: string; hasApiKey: boolean; workspaceName: string; }
export interface UsageSummary { calls: number; totalCostUsd: number; inputTokens: number; outputTokens: number; }
export interface ChatResponse {
  text: string; json: unknown; isMock: boolean; provider: string; model: string;
  usage: { inputTokens: number; outputTokens: number; costUsd: number };
}
